module.exports = __webpack_public_path__ + "img/fiber-f2f-payment.0c2ec0ee.png";